// src/admin/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Wraps any admin route.
 * If adminLoggedIn is not set in sessionStorage, redirects to /admin/login.
 */
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = sessionStorage.getItem("adminLoggedIn") === "true";

  if (!isLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;